export const DEFAULT_LISTENER_DEBOUNCE_INTERVAL = 200;
export const GTM_ID = window.GOOGLE_TAG_MANAGER_ID;
export const CEMETERY_URL = window.CEMETERY_URL || '/';
export const CNAME = window.location.origin;
export const HEADER_PHONE = window.HEADER_PHONE || '';
export const HEADER_PHONE_TEXT = window.HEADER_PHONE_TEXT || '';
export const IS_HIDE_COOKIES_POPUP = window.HIDE_COOKIES_POPUP === true;
export const SERVICES_NO_SLUG_URL = window.ORDER_SERVICES_NO_SLUG_URL;
export const IS_HIDDEN_ORDER_SERVICES = !(
  window.ALIASES_HOSTS_CONFIG?.[window.location.host]?.showOrderServices ?? true
);
